const SPECIAL_REGEX = /[~`!#$%^&*+=\-[\]\\';,/{}|\\":<>?]/

export const getHints = password => {
  return {
    hasTen: password.length >= 10,
    hasSpecial: SPECIAL_REGEX.test(password),
    hasFourUnique: (new Set(password)).size >= 4,
  }
}

export const isValid = ({ password }) => {
  const { hasTen, hasSpecial, hasFourUnique } = getHints(password)
  return [hasTen, hasSpecial, hasFourUnique].every(x => x)
}


// WEBPACK FOOTER //
// ./src/utils/password.js